import { render, staticRenderFns } from "./PenaltyRuns.vue?vue&type=template&id=46a9523e"
import script from "./PenaltyRuns.vue?vue&type=script&lang=js"
export * from "./PenaltyRuns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports